import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';
import { Country } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(@Inject(HttpClient) private readonly http: HttpClient) {}

  getCountries() {
    return this.http.get<{ message: string; data: Country[] }>(`${environment.API_URI}/country`);
  }
}
